<script setup>
/******************************************************************************
 * Component: Form error hint
 *****************************************************************************/
import SvgIcon from "Components/SvgIcon/SvgIcon.vue";
defineProps({
    top: {
        type: Number,
        default: 0,
    },
    bottom: {
        type: Number,
        default: 0,
    },
    errorText: {
        type: String,
        default: "",
    },
    errorArray: {
        type: Array,
        default: () => [],
    },
});
</script>

<template>
    <div v-if="errorText.length > 0" class="error-text">
        <svg-icon name="error" />
        {{ errorText }}
    </div>
    <ul v-if="errorArray.length > 0" class="error-array">
        <li v-for="msg in errorArray" :key="msg">
            <svg-icon name="error" /> {{ msg }}
        </li>
    </ul>
</template>

<style lang="scss" scoped>
.error-text {
    display: flex;

    padding: #{get($sizes, "base") * 0.5};
    border: get($sizes, "border") solid palette("state", "error");
    margin-top: calc(v-bind(top) * get($sizes, "base"));
    margin-bottom: calc(v-bind(bottom) * get($sizes, "base"));
    gap: #{get($sizes, "base") * 0.5};

    background-color: palette("state", "warning");
    color: color.adjust(palette("state", "error"), $lightness: -25%);
    border-radius: get($sizes, "radius");

    font-weight: 400;

    @include respond-to("medium") {
        margin-top: calc(v-bind(top) * get($sizes, "base") * 2);
        margin-bottom: calc(v-bind(bottom) * get($sizes, "base") * 2);
    }
}

.error-array {
    padding: #{get($sizes, "base") * 0.5};
    border: get($sizes, "border") solid palette("state", "error");
    margin-top: calc(v-bind(top) * get($sizes, "base"));
    margin-bottom: calc(v-bind(bottom) * get($sizes, "base"));
    gap: #{get($sizes, "base") * 0.2};

    background-color: palette("state", "warning");
    color: color.adjust(palette("state", "error"), $lightness: -25%);
    list-style: none;
    border-radius: get($sizes, "radius");

    font-weight: 400;

    @include respond-to("medium") {
        margin-top: calc(v-bind(top) * get($sizes, "base") * 2);
        margin-bottom: calc(v-bind(bottom) * get($sizes, "base") * 2);
    }

    > li {
        display: flex;
        align-items: center;

        gap: #{get($sizes, "base") * 0.5};
    }
}
</style>
